import React, {useEffect, useState}  from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {     
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    Label,
    Button,
    Badge,
    Form,
    Input,
    InputGroup, Container,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
 } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import { Link, useHistory } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import * as url from "../../helpers/url_helper"

import toastr from "toastr";
import "toastr/build/toastr.min.css";


import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";
import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';

    const AppraisePAs = () => {

        const history = useHistory()
        const [paList, setPaList] = useState([])
        const [isloading, setIsloading] = useState(false)
        useEffect(() => {
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            const EmployeeNo = obj.uid;
            const CompanyID = obj.activeCompany;
            let urlx = " url string";
          
            urlx = `${url.MPAS}?$filter=Appraiser eq '${EmployeeNo}' and Status eq 'Pending Approval'&$expand=mpaLines,mpaLines2,mpaLines4&company='${CompanyID}'`
            setIsloading(true) 
            axios.get(urlx, HRConfig).then((r)=>{
     
              setPaList(r.data.value);
              //console.log(r)
              setIsloading(false)
            }).catch((e)=>{
              console.log(e)
              setIsloading(false)
            })
          }, []);
        
          const { SearchBar } = Search;
          const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true
          }, 
          {
              dataField: 'PostingDate',
              text: 'Date',
              sort: true
          }, 
          {
              dataField: 'Phase',
              text: 'Phase',
              sort: true,
               // eslint-disable-next-line react/display-name
               formatter: (cellContent, row) => (
                <>{row.Phase}</>
              ),
            }, 
          
          {
              dataField: 'EmployeeNo',
              text: 'Employee No',
              sort: true
            }, 

  
          
            {
              dataField: 'performance1',
              text: 'Overall Performance',
              sort: true,
               // eslint-disable-next-line react/display-name
               formatter: (cellContent, row) => (
                <>
                  <p className="text-muted mb-0"><strong>{row.OverallMidyearAssessment.toFixed(2)}</strong></p>
                  
                </>
              ),
            }, 
          {
            dataField: 'Status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
          },
          {
            dataField: "action",
            isDummyField: true,
            text: "",
            formatter: actionFormatter
          }];
    
          const defaultSorted = [{
            dataField: 'No',
            order: 'desc'
          }];
    
          function linesFormatter(cellContent, row){
            return(
              <strong></strong>
            )
          }
          function noFormatter(cellContent, row){
            return(
              <strong>{cellContent}</strong>
            )
          }
    
          function actionFormatter(cellContent, row){
            return(
              <>
              <Button
                type="button"
                color="info"
                className="btn-sm btn-rounded"
                onClick={()=>{ history.push(`/staff-performance-appraisal/${row.SystemId}`)}}
              >
                Details
              </Button>
            </>
            )
          }
          function statusFormatter(cellContent, row) {
            if (row.Status == "Open") {
              return (
                <div>
                    <Badge className="me-2 bg-danger">
                    { cellContent }
                    </Badge>
                </div>
              );
            }else if (row.Status == "Approved"){
              return (
                <div>
                    <Badge className="me-2 bg-success">
                    { cellContent }
                    </Badge>
                </div>
              );
            }else{
              return (
                <div>
                    <Badge className="me-2 bg-warning">
                    { cellContent }
                    </Badge>
                </div>
              );
            }
          }
          return (
              <>
            <LoadingOverlay
              active={isloading}
              spinner={<ClimbingBoxLoader />}
              text='Please wait...' >
                  <div className="page-content">
                      <MetaTags>
                      <title>Appraise Mid-term Appraisals | HRMIS</title>
                      </MetaTags>
                      <Container fluid={true}>
                          <Breadcrumbs title="Human Resource Management" breadcrumbItem={`Appraise Mid-term appraisals`} />
                          
                      
                        <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <CardTitle></CardTitle>
                    <CardSubtitle className="mb-3">
                      
                    </CardSubtitle>
  
                   {paList && (paList.length > 0) && (
                    <ToolkitProvider
                        keyField="No"
                        data={ paList }
                        columns={ columns }
                        search
                      >
                        { toolkitProps => (
                            <React.Fragment>
                            <Row className='mb-5'>
                                <Col lg={8} className='mb-2'>
                                  <div  className="rounded bg-light d-grid gap-2">
                                    <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                  </div>
                                </Col>
                          
                                <Col lg={4}> 
                             
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table">
                              
                                  <BootstrapTable 
                                    keyField='No' 
                                    data={ paList } 
                                    columns={ columns } 
                                    striped
                                    hover
                                    condensed
                                    bordered={ false }
                                    noDataIndication="No Records" 
                                    defaultSorted={ defaultSorted }
                                    classes={ "table align-middle table-nowrap table-check" }
                                      {...toolkitProps.baseProps}
                                    />
                               </div>
                               </Col>
                               </Row>
                               </React.Fragment>
                              
                        )
                      }
                    </ToolkitProvider>
                    
  
                    )}
                    {paList && (paList.length < 1) && (
                      <div className="text-center">
                        <div className="mb-4">
                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                        </div>
                        <div>
                        <h5>No Performance Appraisal Found</h5>
                        <p className="text-muted">
                                
                        </p>
                        </div>
                    </div>
  
                    )}
                    
                  </CardBody>
                </Card>
              </Col>
            </Row>
  
  
                      </Container>
                  </div>
                  </LoadingOverlay>
              </>
          );
      }
  
export default AppraisePAs;